// src/pages/admin/CreateUserPage.tsx

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../../store/appStore';
import { useAdminStore } from '../../store/adminStore';
import { isValidEmail } from '../../utils/adminUtils';

export function CreateUserPage() {
  const navigate = useNavigate();
  const session = useAppStore((s) => s.session);
  const createUser = useAdminStore((s) => s.createUser);

  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const idToken = session?.idToken || '';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    const trimmedEmail = email.trim();
    if (!isValidEmail(trimmedEmail)) {
      setError('Please enter a valid email address.');
      return;
    }

    setIsSubmitting(true);
    try {
      const userId = await createUser(idToken, trimmedEmail);
      // Navigate to permissions page for the newly created user
      navigate(`/admin/users/${userId}/permissions`);
    } catch (err: unknown) {
      const message = (err as { message?: string })?.message || 'Failed to create user';
      setError(message);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="years-page">
      <div className="years-header">
        <h1>➕ Create User</h1>
        <button
          className="refresh-button"
          onClick={() => navigate('/admin')}
          style={{ minHeight: '44px' }}
        >
          ← Back
        </button>
      </div>

      <form onSubmit={handleSubmit} style={{ maxWidth: '500px' }}>
        <label
          htmlFor="email-input"
          style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontWeight: 600,
            color: 'var(--text)',
          }}
        >
          Email address
        </label>
        <input
          id="email-input"
          className="input"
          type="email"
          placeholder="user@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
          autoFocus
          required
        />

        {error && (
          <div
            className="error-state"
            role="alert"
            style={{ marginTop: '1rem', padding: '0.75rem 1rem' }}
          >
            <p>{error}</p>
          </div>
        )}

        <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.75rem' }}>
          <button
            type="submit"
            className="btn-primary"
            disabled={isSubmitting || !email.trim()}
            style={{ minHeight: '44px' }}
          >
            {isSubmitting ? 'Creating…' : 'Create User'}
          </button>
          <button
            type="button"
            className="btn-secondary"
            onClick={() => navigate('/admin')}
            disabled={isSubmitting}
            style={{ minHeight: '44px' }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
